import React, { useState, useEffect } from 'react';
import BotonMapaProceso from './BotonMapaProceso';
import { subirDatos, eliminarDato, subirDatosSingle } from './syncSupabase';

const CATEGORIAS = ['Packaging', 'Etiqueta', 'Folleto', 'Manual', 'Otro'];

const FORM_VACIO = {
  nombre: '', sku: '', categoria: 'Packaging', cliente: '', ot: '',
  formatoLargo: '', formatoAncho: '', formatoAlto: '',
  tiradaValor: '', tiradaUnidad: 'unidades',
  colores: '', notas: '', origen: 'manual',
  sustrato: '', gramajeValor: '', gramajeUnidad: 'g/m²', proveedor_sustrato: '',
  adhesivo: '', tipo_adhesivo: '', proveedor_adhesivo: '',
  laminado: '', tipo_laminado: '',
  tinta: '', sistema_impresion: '',
  barniz: '', tipo_barniz: '',
  troquel: '', num_troquel: '',
  foto_producto: '', muestra_patron: '', arte_aprobado: '', ficha_pdf: '',
};

export default function EspecificacionesTecnicas({ onVolver, oscuro, usuario }) {
  const [specs, setSpecs] = useState([]);
  const [seleccionada, setSeleccionada] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [filtro, setFiltro] = useState('todos');
  const [tabDetalle, setTabDetalle] = useState('ficha');
  const [editando, setEditando] = useState(false);
  const [tabForm, setTabForm] = useState('general');
  const [form, setForm] = useState(FORM_VACIO);

  useEffect(() => {
    const data = localStorage.getItem('et_specs');
    const etActual = data ? JSON.parse(data) : [];

    const ddData = localStorage.getItem('dd_proyectos');
    if (ddData) {
      const proyectos = JSON.parse(ddData);
      const aprobados = proyectos.filter(p => p.estado === 'aprobado');
      const idsExistentes = etActual.map(e => e.ddId);
      const idsEliminados = JSON.parse(localStorage.getItem('et_eliminados') || '[]');
      const nuevos = aprobados
        .filter(p => !idsExistentes.includes(p.id) && !idsEliminados.includes(p.id))
        .map((p, i) => ({
          ...FORM_VACIO,
          id: Math.floor(Date.now()) + i,
          ddId: p.id,
          nombre: p.nombre,
          sku: `SKU-${String(p.id).slice(-4)}`,
          categoria: 'Packaging',
          cliente: p.cliente || '',
          ot: p.ot || '',
          sustrato: p.material || '',
          colores: p.colores || '',
          barniz: p.acabado || '',
          notas: p.notas || '',
          origen: 'dyd',
          fechaCreacion: new Date().toLocaleDateString('es-AR'),
          version: p.version || 1,
        }));
      const lista = [...nuevos, ...etActual];
      setSpecs(lista);
      if (nuevos.length > 0) { localStorage.setItem('et_specs', JSON.stringify(lista)); subirDatos('et_specs'); }
      else setSpecs(etActual);
    } else {
      setSpecs(etActual);
    }
  }, []);

  const guardar = (lista) => { setSpecs(lista); localStorage.setItem('et_specs', JSON.stringify(lista)); subirDatos('et_specs'); };

  const eliminarSpec = async (id) => {
    if (!window.confirm('¿Eliminar esta especificación?')) return;
    const nuevas = specs.filter(s => s.id !== id);
    setSpecs(nuevas);
    localStorage.setItem('et_specs', JSON.stringify(nuevas));
    await eliminarDato('et_specs', id);
    // Guardar id eliminado para no reimportar desde DyD
    const eliminados = JSON.parse(localStorage.getItem('et_eliminados') || '[]');
    const spec = specs.find(s => s.id === id);
    if (spec?.ddId) {
      const nuevosEliminados = [...eliminados, spec.ddId];
      localStorage.setItem('et_eliminados', JSON.stringify(nuevosEliminados));
      subirDatosSingle('et_eliminados', 'et_eliminados');
    }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const editarSpec = () => {
    if (!form.nombre.trim()) return alert('El nombre es obligatorio');
    const actualizada = { ...seleccionada, ...form, version: seleccionada.version };
    const lista = specs.map(s => s.id === seleccionada.id ? actualizada : s);
    guardar(lista);
    setSeleccionada(actualizada);
    setEditando(false);
    setShowForm(false);
    setTabForm('general');
  };

  const abrirEditar = (spec) => {
    setForm({ ...FORM_VACIO, ...spec });
    setEditando(true);
    setShowForm(true);
    setTabForm('general');
  };

  const agregarSpec = () => {
    if (!form.nombre.trim()) return alert('El nombre es obligatorio');
    const nueva = { ...form, id: Date.now(), ddId: null, origen: 'manual', fechaCreacion: new Date().toLocaleDateString('es-AR'), version: 1 };
    guardar([nueva, ...specs]);
    setShowForm(false);
    setForm(FORM_VACIO);
    setTabForm('general');
  };

  const specsFiltradas = filtro === 'todos' ? specs : specs.filter(s => s.categoria === filtro);

  const inp = { width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #E5E7EB', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'Inter, sans-serif' };
  const lbl = { fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '4px', display: 'block' };
  const secTit = { fontSize: '11px', fontWeight: '700', color: '#1C3FAA', margin: '14px 0 8px', paddingBottom: '5px', borderBottom: '1px solid #E8E9F6', textTransform: 'uppercase', letterSpacing: '0.08em' };

  const TabBtn = ({ id, label, active, onClick }) => (
    <button onClick={onClick} style={{ padding: '7px 14px', borderRadius: '8px', border: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer', background: active ? '#1C3FAA' : 'transparent', color: active ? 'white' : '#6B7280' }}>{label}</button>
  );

  const Campo = ({ k, v }) => v ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '6px', paddingBottom: '6px', borderBottom: '1px solid #F9FAFB' }}>
      <span style={{ color: '#6B7280' }}>{k}</span>
      <span style={{ color: '#111827', fontWeight: '500', textAlign: 'right', maxWidth: '60%' }}>{v}</span>
    </div>
  ) : null;

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif', background: '#E8E9F6', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button onClick={onVolver} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', color: '#6B7280' }}>← Menú</button>
            <span style={{ fontSize: '22px' }}>📌</span>
            <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>Especificaciones Técnicas</h1>
            <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1C3FAA', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>ISO 9001 §8.5</span>
            {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="especificaciones_tecnicas" oscuro={oscuro} />}
          </div>
          <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px', marginLeft: '32px' }}>Repositorio central de fichas técnicas · Vinculado con DyD y OT</p>
        </div>
        <button onClick={() => setShowForm(true)} style={{ background: '#1C3FAA', color: 'white', border: 'none', borderRadius: '10px', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>+ Nueva especificación</button>
      </div>

      {/* Métricas */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
        {[
          { label: 'Total specs', valor: specs.length, color: '#1C3FAA' },
          { label: 'Desde DyD', valor: specs.filter(s => s.origen === 'dyd').length, color: '#16a34a' },
          { label: 'Manuales', valor: specs.filter(s => s.origen === 'manual').length, color: '#6B6FD6' },
          { label: 'Con troquel', valor: specs.filter(s => s.troquel).length, color: '#d97706' },
        ].map((m, i) => (
          <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '14px 16px', border: '1px solid #E5E7EB' }}>
            <div style={{ fontSize: '11px', color: '#6B7280', marginBottom: '4px' }}>{m.label}</div>
            <div style={{ fontSize: '26px', fontWeight: '700', color: m.color }}>{m.valor}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: '4px', marginBottom: '14px', background: 'white', padding: '4px', borderRadius: '10px', border: '1px solid #E5E7EB', width: 'fit-content' }}>
        {['todos', ...CATEGORIAS].map(f => (
          <TabBtn key={f} id={f} label={f === 'todos' ? 'Todos' : f} active={filtro === f} onClick={() => setFiltro(f)} />
        ))}
      </div>

      {/* Layout */}
      <div style={{ display: 'grid', gridTemplateColumns: seleccionada ? '1fr 420px' : '1fr', gap: '14px' }}>

        {/* Tabla */}
        <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
          {specsFiltradas.length === 0 ? (
            <div style={{ padding: '60px', textAlign: 'center', color: '#9CA3AF' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>📌</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>Sin especificaciones</div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>Se importan automáticamente desde DyD al aprobar</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Nombre / SKU', 'Categoría', 'Cliente', 'Sustrato', 'Adhesivo', 'Troquel', 'Origen', 'v', ''].map(h => (
                    <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {specsFiltradas.map(s => (
                  <tr key={s.id} onClick={() => { setSeleccionada(s); setTabDetalle('ficha'); }}
                    style={{ cursor: 'pointer', background: seleccionada?.id === s.id ? '#EFF6FF' : 'white' }}
                    onMouseEnter={e => { if (seleccionada?.id !== s.id) e.currentTarget.style.background = '#F9FAFB'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = seleccionada?.id === s.id ? '#EFF6FF' : 'white'; }}>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                      <div style={{ fontWeight: '600', fontSize: '13px', color: '#111827' }}>{s.nombre}</div>
                      <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{s.sku} · {s.fechaCreacion}</div>
                    </td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                      <span style={{ background: '#E8E9F6', color: '#1C3FAA', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>{s.categoria}</span>
                    </td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{s.cliente || '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{s.sustrato || '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#374151', borderBottom: '1px solid #F3F4F6' }}>{s.adhesivo || '—'}</td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', borderBottom: '1px solid #F3F4F6' }}>
                      {s.troquel ? <span style={{ background: '#fef3c7', color: '#d97706', fontSize: '11px', padding: '2px 7px', borderRadius: '6px', fontWeight: '600' }}>#{s.num_troquel || 'S/N'}</span> : <span style={{ color: '#D1D5DB' }}>—</span>}
                    </td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                      {s.origen === 'dyd'
                        ? <span style={{ background: '#dcfce7', color: '#16a34a', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>← DyD</span>
                        : <span style={{ background: '#F3F4F6', color: '#6B7280', fontSize: '11px', padding: '2px 8px', borderRadius: '6px' }}>Manual</span>}
                    </td>
                    <td style={{ padding: '11px 14px', fontSize: '12px', color: '#6B7280', borderBottom: '1px solid #F3F4F6' }}>v{s.version}</td>
                    <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }} onClick={e => e.stopPropagation()}>
                      <button onClick={() => eliminarSpec(s.id)} style={{ background: 'none', border: '1px solid #fee2e2', color: '#dc2626', borderRadius: '6px', padding: '3px 8px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Panel detalle */}
        {seleccionada && (
          <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden', maxHeight: '80vh', overflowY: 'auto' }}>
            <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontWeight: '700', fontSize: '14px', color: '#111827' }}>{seleccionada.nombre}</div>
                <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>{seleccionada.sku} · v{seleccionada.version} · {seleccionada.cliente}</div>
                <div style={{ marginTop: '6px', display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                  {seleccionada.origen === 'dyd' && <span style={{ background: '#dcfce7', color: '#16a34a', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>✓ DyD</span>}
                  {seleccionada.ot && <span style={{ background: '#dbeafe', color: '#1d4ed8', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>OT-{seleccionada.ot}</span>}
                  <span style={{ background: '#E8E9F6', color: '#1C3FAA', fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>{seleccionada.categoria}</span>
                </div>
              </div>
              <button onClick={() => abrirEditar(seleccionada)} style={{ background: '#1C3FAA', color: 'white', border: 'none', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', marginRight: '8px' }}>✏️ Editar</button><button onClick={() => setSeleccionada(null)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
            </div>

            {/* Tabs detalle */}
            <div style={{ display: 'flex', gap: '2px', padding: '8px 12px', borderBottom: '1px solid #F3F4F6', background: '#F9FAFB' }}>
              {[['ficha','📋 Ficha'],['materiales','🧪 Materiales'],['archivos','📎 Archivos']].map(([id, lbl]) => (
                <button key={id} onClick={() => setTabDetalle(id)}
                  style={{ padding: '5px 12px', borderRadius: '7px', border: 'none', fontSize: '11px', fontWeight: '500', cursor: 'pointer', background: tabDetalle === id ? '#1C3FAA' : 'transparent', color: tabDetalle === id ? 'white' : '#6B7280' }}>{lbl}</button>
              ))}
            </div>

            <div style={{ padding: '14px 16px' }}>
              {tabDetalle === 'ficha' && (<>
                <Campo k="Formato / dimensiones" v={(seleccionada.formatoLargo||seleccionada.formatoAncho||seleccionada.formatoAlto) ? `${seleccionada.formatoLargo||'—'}×${seleccionada.formatoAncho||'—'}×${seleccionada.formatoAlto||'—'} mm` : ''} />
                <Campo k="Colores de impresión" v={seleccionada.colores} />
                <Campo k="Sistema de impresión" v={seleccionada.sistema_impresion} />
                <Campo k="Tirada" v={seleccionada.tiradaValor ? `${Number(seleccionada.tiradaValor).toLocaleString('es-AR')} ${seleccionada.tiradaUnidad||''}` : ''} />
                <Campo k="Fecha creación" v={seleccionada.fechaCreacion} />
                {seleccionada.notas && (
                  <div style={{ marginTop: '10px', background: '#F9FAFB', borderRadius: '8px', padding: '10px', fontSize: '12px', color: '#374151' }}>
                    <div style={{ fontWeight: '600', marginBottom: '4px', color: '#6B7280', fontSize: '11px' }}>Notas</div>
                    {seleccionada.notas}
                  </div>
                )}
              </>)}

              {tabDetalle === 'materiales' && (<>
                <div style={secTit}>🗂 Sustrato</div>
                <Campo k="Material" v={seleccionada.sustrato} />
                <Campo k="Gramaje" v={seleccionada.gramajeValor ? `${seleccionada.gramajeValor} ${seleccionada.gramajeUnidad||''}` : ''} />
                <Campo k="Proveedor" v={seleccionada.proveedor_sustrato} />

                <div style={secTit}>🔗 Adhesivo</div>
                <Campo k="Adhesivo" v={seleccionada.adhesivo} />
                <Campo k="Tipo" v={seleccionada.tipo_adhesivo} />
                <Campo k="Proveedor" v={seleccionada.proveedor_adhesivo} />

                <div style={secTit}>✨ Laminado</div>
                <Campo k="Laminado" v={seleccionada.laminado} />
                <Campo k="Tipo" v={seleccionada.tipo_laminado} />

                <div style={secTit}>🎨 Tinta y barniz</div>
                <Campo k="Tinta" v={seleccionada.tinta} />
                <Campo k="Barniz / acabado" v={seleccionada.barniz} />
                <Campo k="Tipo barniz" v={seleccionada.tipo_barniz} />

                <div style={secTit}>✂️ Troquel</div>
                <Campo k="Troquel" v={seleccionada.troquel} />
                <Campo k="N° troquel" v={seleccionada.num_troquel} />
              </>)}

              {tabDetalle === 'archivos' && (<>
                {[
                  { k: 'Foto producto terminado', v: seleccionada.foto_producto, icon: '📸' },
                  { k: 'Muestra patrón / troquel', v: seleccionada.muestra_patron, icon: '🗺️' },
                  { k: 'Arte aprobado', v: seleccionada.arte_aprobado, icon: '🎨' },
                  { k: 'Ficha técnica PDF', v: seleccionada.ficha_pdf, icon: '📄' },
                ].map(({ k, v, icon }) => (
                  <div key={k} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', borderRadius: '9px', border: '1px solid #E5E7EB', marginBottom: '8px', background: v ? '#F0FDF4' : '#F9FAFB' }}>
                    <span style={{ fontSize: '20px' }}>{icon}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>{k}</div>
                      <div style={{ fontSize: '11px', color: v ? '#16a34a' : '#9CA3AF', marginTop: '2px' }}>{v || 'Sin archivo cargado'}</div>
                    </div>
                    {v && <span style={{ fontSize: '11px', background: '#dcfce7', color: '#16a34a', padding: '2px 7px', borderRadius: '6px', fontWeight: '600' }}>✓</span>}
                  </div>
                ))}
              </>)}
            </div>
          </div>
        )}
      </div>

      {/* Modal form */}
      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '580px', maxHeight: '92vh', overflowY: 'auto', padding: '24px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>{editando ? '✏️ Editar especificación' : '📌 Nueva especificación técnica'}</h2>
              <button onClick={() => { setShowForm(false); setTabForm('general'); }} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
            </div>
            <p style={{ fontSize: '12px', color: '#9CA3AF', margin: '0 0 12px' }}>ISO 9001 §8.5 · Ficha completa de producto</p>

            {/* Tabs form */}
            <div style={{ display: 'flex', gap: '4px', background: '#F9FAFB', padding: '4px', borderRadius: '10px', marginBottom: '16px' }}>
              {[['general','📋 General'],['materiales','🧪 Materiales'],['archivos','📎 Archivos']].map(([id, lb]) => (
                <button key={id} onClick={() => setTabForm(id)}
                  style={{ flex: 1, padding: '7px', borderRadius: '8px', border: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer', background: tabForm === id ? '#1C3FAA' : 'transparent', color: tabForm === id ? 'white' : '#6B7280' }}>{lb}</button>
              ))}
            </div>

            {tabForm === 'general' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={lbl}>Nombre del producto *</label>
                  <input style={inp} placeholder="Ej: Caja Cereal Primavera" value={form.nombre} onChange={e => set('nombre', e.target.value)} />
                </div>
                <div><label style={lbl}>SKU</label><input style={inp} placeholder="Ej: SKU-0042" value={form.sku} onChange={e => set('sku', e.target.value)} /></div>
                <div><label style={lbl}>Categoría</label>
                  <select style={inp} value={form.categoria} onChange={e => set('categoria', e.target.value)}>{CATEGORIAS.map(c => <option key={c}>{c}</option>)}</select>
                </div>
                <div><label style={lbl}>Cliente</label><input style={inp} placeholder="Ej: Arcor SA" value={form.cliente} onChange={e => set('cliente', e.target.value)} /></div>
                <div><label style={lbl}>OT vinculada</label><input style={inp} placeholder="Ej: 1284" value={form.ot} onChange={e => set('ot', e.target.value)} /></div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={lbl}>Formato / dimensiones (mm)</label>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px' }}>
                    <input style={inp} type="number" placeholder="Largo" value={form.formatoLargo} onChange={e => set('formatoLargo', e.target.value)} />
                    <input style={inp} type="number" placeholder="Ancho" value={form.formatoAncho} onChange={e => set('formatoAncho', e.target.value)} />
                    <input style={inp} type="number" placeholder="Alto" value={form.formatoAlto} onChange={e => set('formatoAlto', e.target.value)} />
                  </div>
                </div>
                <div><label style={lbl}>Colores de impresión</label><input style={inp} placeholder="Ej: CMYK + Pantone 186" value={form.colores} onChange={e => set('colores', e.target.value)} /></div>
                <div><label style={lbl}>Sistema de impresión</label>
                  <select style={inp} value={form.sistema_impresion} onChange={e => set('sistema_impresion', e.target.value)}>
                    <option value="">Seleccionar...</option>
                    {['Offset','Flexografía','Huecograbado','Digital','Serigrafía'].map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Tirada</label>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                    <input style={inp} type="number" placeholder="Ej: 50000" value={form.tiradaValor} onChange={e => set('tiradaValor', e.target.value)} />
                    <input style={inp} placeholder="Ej: unidades" value={form.tiradaUnidad} onChange={e => set('tiradaUnidad', e.target.value)} />
                  </div>
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={lbl}>Notas</label>
                  <textarea style={{ ...inp, minHeight: '60px', resize: 'vertical' }} placeholder="Observaciones, requisitos especiales..." value={form.notas} onChange={e => set('notas', e.target.value)} />
                </div>
              </div>
            )}

            {tabForm === 'materiales' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div style={{ gridColumn: '1/-1', ...secTit }}>🗂 Sustrato</div>
                <div><label style={lbl}>Material / sustrato</label><input style={inp} placeholder="Ej: Cartulina SBS" value={form.sustrato} onChange={e => set('sustrato', e.target.value)} /></div>
                <div>
                  <label style={lbl}>Gramaje</label>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                    <input style={inp} type="number" placeholder="Ej: 300" value={form.gramajeValor} onChange={e => set('gramajeValor', e.target.value)} />
                    <input style={inp} placeholder="Ej: g/m²" value={form.gramajeUnidad} onChange={e => set('gramajeUnidad', e.target.value)} />
                  </div>
                </div>
                <div style={{ gridColumn: '1/-1' }}><label style={lbl}>Proveedor sustrato</label><input style={inp} placeholder="Nombre del proveedor" value={form.proveedor_sustrato} onChange={e => set('proveedor_sustrato', e.target.value)} /></div>

                <div style={{ gridColumn: '1/-1', ...secTit }}>🔗 Adhesivo</div>
                <div><label style={lbl}>Adhesivo</label><input style={inp} placeholder="Ej: Hot melt, Solvent..." value={form.adhesivo} onChange={e => set('adhesivo', e.target.value)} /></div>
                <div><label style={lbl}>Tipo</label>
                  <select style={inp} value={form.tipo_adhesivo} onChange={e => set('tipo_adhesivo', e.target.value)}>
                    <option value="">Seleccionar...</option>
                    {['Permanente','Removible','Ultra removible','Congelador','Alta temperatura'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div style={{ gridColumn: '1/-1' }}><label style={lbl}>Proveedor adhesivo</label><input style={inp} placeholder="Nombre del proveedor" value={form.proveedor_adhesivo} onChange={e => set('proveedor_adhesivo', e.target.value)} /></div>

                <div style={{ gridColumn: '1/-1', ...secTit }}>✨ Laminado</div>
                <div><label style={lbl}>Laminado</label><input style={inp} placeholder="Ej: BOPP, PET..." value={form.laminado} onChange={e => set('laminado', e.target.value)} /></div>
                <div><label style={lbl}>Tipo</label>
                  <select style={inp} value={form.tipo_laminado} onChange={e => set('tipo_laminado', e.target.value)}>
                    <option value="">Seleccionar...</option>
                    {['Mate','Brillante','Soft touch','Holográfico'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>

                <div style={{ gridColumn: '1/-1', ...secTit }}>🎨 Tinta y barniz</div>
                <div><label style={lbl}>Tinta</label><input style={inp} placeholder="Ej: UV, base agua..." value={form.tinta} onChange={e => set('tinta', e.target.value)} /></div>
                <div><label style={lbl}>Barniz / acabado</label><input style={inp} placeholder="Ej: Barniz UV selectivo" value={form.barniz} onChange={e => set('barniz', e.target.value)} /></div>
                <div style={{ gridColumn: '1/-1' }}><label style={lbl}>Tipo barniz</label>
                  <select style={inp} value={form.tipo_barniz} onChange={e => set('tipo_barniz', e.target.value)}>
                    <option value="">Seleccionar...</option>
                    {['UV total','UV selectivo','Aquoso','Plastificado mate','Plastificado brillo'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>

                <div style={{ gridColumn: '1/-1', ...secTit }}>✂️ Troquel</div>
                <div><label style={lbl}>Descripción troquel</label><input style={inp} placeholder="Ej: Troquel caja automática" value={form.troquel} onChange={e => set('troquel', e.target.value)} /></div>
                <div><label style={lbl}>N° troquel</label><input style={inp} placeholder="Ej: TQ-0042" value={form.num_troquel} onChange={e => set('num_troquel', e.target.value)} /></div>
              </div>
            )}

            {tabForm === 'archivos' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <p style={{ fontSize: '12px', color: '#6B7280', margin: 0 }}>Ingresá el nombre o referencia del archivo. La carga de archivos real se hará desde Supabase Storage próximamente.</p>
                {[
                  { k: 'foto_producto', label: 'Foto del producto terminado', icon: '📸', ph: 'Ej: foto_caja_cereal_v3.jpg' },
                  { k: 'muestra_patron', label: 'Muestra patrón / estructura de corte (troquel)', icon: '🗺️', ph: 'Ej: troquel_caja_cereal.pdf' },
                  { k: 'arte_aprobado', label: 'Arte aprobado por cliente', icon: '🎨', ph: 'Ej: arte_aprobado_arcor_v3.pdf' },
                  { k: 'ficha_pdf', label: 'Ficha técnica PDF', icon: '📄', ph: 'Ej: ficha_tecnica_SKU0042.pdf' },
                ].map(({ k, label, icon, ph }) => (
                  <div key={k}>
                    <label style={lbl}>{icon} {label}</label>
                    <input style={inp} placeholder={ph} value={form[k]} onChange={e => set(k, e.target.value)} />
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => { setShowForm(false); setTabForm('general'); }}
                style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid #E5E7EB', background: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#6B7280' }}>Cancelar</button>
              <button onClick={editando ? editarSpec : agregarSpec}
                style={{ flex: 2, padding: '10px', borderRadius: '10px', border: 'none', background: '#1C3FAA', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Guardar especificación</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
